import React from 'react';

import cn from 'classnames';
import PropTypes from 'prop-types';
import {ensuredForwardRef} from 'react-use';

import bem from 'client/services/bem';
import {blobToBase64} from 'client/services/blobToBase64';

import AppButton from 'client/common/buttons/app-button';

import './file-button.scss';

const b = bem('file-button');

/**
 *
 * @type {React.FC<FileButton.PropTypes>}
 */

// TODO: from jsx => tsx

const FileButton = ensuredForwardRef((props, ref) => {
  const {
    name = 'add-file',
    onChange = null,
    onClick = null,
    className = '',
    acceptFormats = '',
    base64 = false,
    maxSize = null,
    onSizeError = null,
    loading = false,
    disabled = false,
    ...button
  } = props;

  const handleClick = () => {
    if (loading || disabled) {
      return;
    }

    if (onClick) {
      onClick(ref);
    } else {
      ref.current.click();
    }
  };

  const onClickHandler = (e) => {
    e.target.value = '';
  };

  const onChangeHandler = async (e) => {
    const nativeFile = e.target.files[0];
    if (!nativeFile) {
      return;
    }

    if (maxSize && nativeFile.size > maxSize) {
      onSizeError?.(nativeFile);
      return;
    }

    const file = base64 ? await blobToBase64(nativeFile) : nativeFile;
    onChange(file, nativeFile.name, nativeFile.type);
  };

  return (
    <React.Fragment>
      <AppButton
        {...button}
        loading={loading}
        disabled={disabled}
        className={cn(className, b('button'))}
        onClick={handleClick}
      />
      <input
        ref={ref}
        name={name}
        type="file"
        disabled={loading || disabled}
        onChange={onChangeHandler}
        onClick={onClickHandler}
        className={b('input')}
        accept={acceptFormats}
      />
    </React.Fragment>
  );
});

FileButton.propTypes = {
  base64: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  className: PropTypes.string,
  acceptFormats: PropTypes.string,
  // Hard limit in bytes — a bigger file is rejected and onChange never fires.
  maxSize: PropTypes.number,
  onSizeError: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default FileButton;
